<template>
  <div :class="giveMeClass"><slot></slot></div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export class PCol extends Vue {
  @Prop({ required: false }) col!: string;
  @Prop({ required: false }) xs!: string;
  @Prop({ required: false }) sm!: string;
  @Prop({ required: false }) md!: string;
  @Prop({ required: false }) lg!: string;
  @Prop({ required: false }) xl!: string;
  @Prop({ required: false }) xxl!: string;
  get giveMeClass(): string {
    let classString = "divPCol divPColPadding";

    if (this.col) {
      classString += ` divPCol_${this.col}`;
    }
    if (this.sm) {
      classString += ` divPCol_sm_${this.sm}`;
    }
    if (this.md) {
      classString += ` divPCol_md_${this.md}`;
    }
    if (this.lg) {
      classString += ` divPCol_lg_${this.lg}`;
    }
    if (this.xl) {
      classString += ` divPCol_xl_${this.xl}`;
    }
    if (this.xxl) {
      classString += ` divPCol_xxl_${this.xxl}`;
    }

    return classString;
  }
}
export default PCol;
</script>
<style scoped>
.divPColPadding {
  padding: 0 1rem 0.5rem 1rem;
  margin-bottom: 0.2rem;
}
.divPCol {
  flex: 0 0 100%;
  max-width: 100%;
}
.divPCol_1 {
  flex: 0 0 8.33%;
  max-width: 8.33%;
}
.divPCol_2 {
  flex: 0 0 16.66%;
  max-width: 16.66%;
}
.divPCol_3 {
  flex: 0 0 24.99%;
  max-width: 24.99%;
}
.divPCol_4 {
  flex: 0 0 33.32%;
  max-width: 33.32%;
}
.divPCol_5 {
  flex: 0 0 41.65%;
  max-width: 41.65%;
}
.divPCol_6 {
  flex: 0 0 49.98%;
  max-width: 49.98%;
}
.divPCol_7 {
  flex: 0 0 58.31%;
  max-width: 58.31%;
}
.divPCol_8 {
  flex: 0 0 66.64%;
  max-width: 66.64%;
}
.divPCol_9 {
  flex: 0 0 74.97%;
  max-width: 74.97%;
}
.divPCol_10 {
  flex: 0 0 83.33%;
  max-width: 83.33%;
}
.divPCol_11 {
  flex: 0 0 91.63%;
  max-width: 91.63%;
}
.divPCol_12 {
  flex: 0 0 100%;
  max-width: 100%;
}

@media (min-width: 576px) {
  .divPCol_sm_1 {
    flex: 0 0 8.33%;
    max-width: 8.33%;
  }
  .divPCol_sm_2 {
    flex: 0 0 16.66%;
    max-width: 16.66%;
  }
  .divPCol_sm_3 {
    flex: 0 0 24.99%;
    max-width: 24.99%;
  }
  .divPCol_sm_4 {
    flex: 0 0 33.32%;
    max-width: 33.32%;
  }
  .divPCol_sm_5 {
    flex: 0 0 41.65%;
    max-width: 41.65%;
  }
  .divPCol_sm_6 {
    flex: 0 0 49.98%;
    max-width: 49.98%;
  }
  .divPCol_sm_7 {
    flex: 0 0 58.31%;
    max-width: 58.31%;
  }
  .divPCol_sm_8 {
    flex: 0 0 66.64%;
    max-width: 66.64%;
  }
  .divPCol_sm_9 {
    flex: 0 0 74.97%;
    max-width: 74.97%;
  }
  .divPCol_sm_10 {
    flex: 0 0 83.33%;
    max-width: 83.33%;
  }
  .divPCol_sm_11 {
    flex: 0 0 91.63%;
    max-width: 91.63%;
  }
  .divPCol_sm_12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
@media (min-width: 768px) {
  .divPCol_md_1 {
    flex: 0 0 8.33%;
    max-width: 8.33%;
  }
  .divPCol_md_2 {
    flex: 0 0 16.66%;
    max-width: 16.66%;
  }
  .divPCol_md_3 {
    flex: 0 0 24.99%;
    max-width: 24.99%;
  }
  .divPCol_md_4 {
    flex: 0 0 33.32%;
    max-width: 33.32%;
  }
  .divPCol_md_5 {
    flex: 0 0 41.65%;
    max-width: 41.65%;
  }
  .divPCol_md_6 {
    flex: 0 0 49.98%;
    max-width: 49.98%;
  }
  .divPCol_md_7 {
    flex: 0 0 58.31%;
    max-width: 58.31%;
  }
  .divPCol_md_8 {
    flex: 0 0 66.64%;
    max-width: 66.64%;
  }
  .divPCol_md_9 {
    flex: 0 0 74.97%;
    max-width: 74.97%;
  }
  .divPCol_md_10 {
    flex: 0 0 83.33%;
    max-width: 83.33%;
  }
  .divPCol_md_11 {
    flex: 0 0 91.63%;
    max-width: 91.63%;
  }
  .divPCol_md_12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
@media (min-width: 992px) {
  .divPCol_lg_1 {
    flex: 0 0 8.33%;
    max-width: 8.33%;
  }
  .divPCol_lg_2 {
    flex: 0 0 16.66%;
    max-width: 16.66%;
  }
  .divPCol_lg_3 {
    flex: 0 0 24.99%;
    max-width: 24.99%;
  }
  .divPCol_lg_4 {
    flex: 0 0 33.32%;
    max-width: 33.32%;
  }
  .divPCol_lg_5 {
    flex: 0 0 41.65%;
    max-width: 41.65%;
  }
  .divPCol_lg_6 {
    flex: 0 0 49.98%;
    max-width: 49.98%;
  }
  .divPCol_lg_7 {
    flex: 0 0 58.31%;
    max-width: 58.31%;
  }
  .divPCol_lg_8 {
    flex: 0 0 66.64%;
    max-width: 66.64%;
  }
  .divPCol_lg_9 {
    flex: 0 0 74.97%;
    max-width: 74.97%;
  }
  .divPCol_lg_10 {
    flex: 0 0 83.33%;
    max-width: 83.33%;
  }
  .divPCol_lg_11 {
    flex: 0 0 91.63%;
    max-width: 91.63%;
  }
  .divPCol_lg_12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
@media (min-width: 1200px) {
  .divPCol_xl_1 {
    flex: 0 0 8.33%;
    max-width: 8.33%;
  }
  .divPCol_xl_2 {
    flex: 0 0 16.66%;
    max-width: 16.66%;
  }
  .divPCol_xl_3 {
    flex: 0 0 24.99%;
    max-width: 24.99%;
  }
  .divPCol_xl_4 {
    flex: 0 0 33.32%;
    max-width: 33.32%;
  }
  .divPCol_xl_5 {
    flex: 0 0 41.65%;
    max-width: 41.65%;
  }
  .divPCol_xl_6 {
    flex: 0 0 49.98%;
    max-width: 49.98%;
  }
  .divPCol_xl_7 {
    flex: 0 0 58.31%;
    max-width: 58.31%;
  }
  .divPCol_xl_8 {
    flex: 0 0 66.64%;
    max-width: 66.64%;
  }
  .divPCol_xl_9 {
    flex: 0 0 74.97%;
    max-width: 74.97%;
  }
  .divPCol_xl_10 {
    flex: 0 0 83.33%;
    max-width: 83.33%;
  }
  .divPCol_xl_11 {
    flex: 0 0 91.63%;
    max-width: 91.63%;
  }
  .divPCol_xl_12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
@media (min-width: 1400px) {
  .divPCol_xxl_1 {
    flex: 0 0 8.33%;
    max-width: 8.33%;
  }
  .divPCol_xxl_2 {
    flex: 0 0 16.66%;
    max-width: 16.66%;
  }
  .divPCol_xxl_3 {
    flex: 0 0 24.99%;
    max-width: 24.99%;
  }
  .divPCol_xxl_4 {
    flex: 0 0 33.32%;
    max-width: 33.32%;
  }
  .divPCol_xxl_5 {
    flex: 0 0 41.65%;
    max-width: 41.65%;
  }
  .divPCol_xxl_6 {
    flex: 0 0 49.98%;
    max-width: 49.98%;
  }
  .divPCol_xxl_7 {
    flex: 0 0 58.31%;
    max-width: 58.31%;
  }
  .divPCol_xxl_8 {
    flex: 0 0 66.64%;
    max-width: 66.64%;
  }
  .divPCol_xxl_9 {
    flex: 0 0 74.97%;
    max-width: 74.97%;
  }
  .divPCol_xxl_10 {
    flex: 0 0 83.33%;
    max-width: 83.33%;
  }
  .divPCol_xxl_11 {
    flex: 0 0 91.63%;
    max-width: 91.63%;
  }
  .divPCol_xxl_12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
</style>
